import React from 'react'

import { getAspectRatioPadding } from './utils/getAspectRatioPadding'

import { TIconProps } from './iconProps'

const IconCheckmarkInCircle: React.FC<TIconProps> = (props) => {
  return (
    <div style={props.style} className={`select-none ${props.className || 'w-24'}`} onClick={props.onClick}>
      <div className="relative h-0" style={getAspectRatioPadding(props.aspectRatio)}>
        <svg xmlns="http://www.w3.org/2000/svg" className="w-full h-full left-0 top-0 absolute" viewBox="0 0 48 48">
          <circle cx="24" cy="24" r="23" stroke="currentColor" strokeWidth="2" fill="none" />
          <path
            d="M16.0914 23.6936C15.646 23.367 15.0202 23.4633 14.6936 23.9086C14.367 24.354 14.4633 24.9798 14.9086 25.3064L16.0914 23.6936ZM23 30L22.4086 30.8064C22.8247 31.1115 23.4046 31.05 23.7474 30.6644L23 30ZM35.7474 17.1644C36.1143 16.7516 36.0771 16.1195 35.6644 15.7526C35.2516 15.3857 34.6195 15.4229 34.2526 15.8356L35.7474 17.1644ZM14.9086 25.3064L22.4086 30.8064L23.5914 29.1936L16.0914 23.6936L14.9086 25.3064ZM23.7474 30.6644L35.7474 17.1644L34.2526 15.8356L22.2526 29.3356L23.7474 30.6644Z"
            fill="currentColor"
          />
        </svg>
      </div>
    </div>
  )
}
export default IconCheckmarkInCircle
